import { createAction, props } from '@ngrx/store';
import {Destination} from '../../../services/api/destinations/destination.model';
import {UUID} from '../../../shared/types/uuid.type';

const prefix = '[Destinations] ';

export const loadDestinations = createAction(
  `${prefix} Load Destinations`
);

export const loadDestinationsSuccess = createAction(
  `${prefix} Load Destinations Success`,
  props<{ data: Destination[] }>()
);

export const loadDestinationsFailure = createAction(
  `${prefix} Load Destinations Failure`,
  props<{ error: any }>()
);

export const manyDestinationsStarted = createAction(
  `${prefix} Many Destinations Started`,
  props<{ ids: UUID[] }>()
);

export const manyDestinationsStopped = createAction(
  `${prefix} Many Destinations Stopped`,
  props<{ ids: UUID[] }>()
);

export const manyDestinationsDeleted = createAction(
  `${prefix} Many Destinations Deleted`,
  props<{ ids: UUID[] }>()
);

export const clearDestinationsState = createAction(
  `${prefix} Clear Destinations State`,
);
